<template>
    <div class="youtube-embed rounded-xl" :style="{ height }">
        <iframe
            v-if="playing"
            :src="`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`"
            :title="title"
            width="100%"
            height="100%"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
        ></iframe>
        <button v-else type="button" class="youtube-poster" :aria-label="`Αναπαραγωγή: ${title}`" @click="playing = true">
            <img :src="`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`" :alt="title" loading="lazy">
            <span class="youtube-play" aria-hidden="true">
                <svg viewBox="0 0 68 48" width="68" height="48"><path d="M66.5 7.7a8.5 8.5 0 0 0-6-6C55.2.2 34 .2 34 .2s-21.2 0-26.5 1.5a8.5 8.5 0 0 0-6 6C0 13 0 24 0 24s0 11 1.5 16.3a8.5 8.5 0 0 0 6 6C12.8 47.8 34 47.8 34 47.8s21.2 0 26.5-1.5a8.5 8.5 0 0 0 6-6C68 35 68 24 68 24s0-11-1.5-16.3z" fill="#ad282d"/><path d="M45 24 27 14v20z" fill="#fff"/></svg>
            </span>
        </button>
    </div>
</template>

<script>
// Shows the video's thumbnail and only loads YouTube's player (around 1 MB of scripts) when clicked
export default {
    name: 'YoutubeEmbed',
    props: {
        videoId: { type: String, required: true },
        title: { type: String, default: 'YouTube video' },
        height: { type: String, default: '300px' }
    },
    data: () => ({
        playing: false
    })
}
</script>

<style scoped>
.youtube-embed {
    position: relative;
    width: 100%;
    overflow: hidden;
    background: #000;
}

.youtube-poster {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    padding: 0;
    border: 0;
    cursor: pointer;
    background: #000;
}

.youtube-poster img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.9;
    transition: opacity 0.2s;
}

.youtube-poster:hover img {
    opacity: 1;
}

.youtube-play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    line-height: 0;
}
</style>
